export default "__VITE_ASSET__BC$3$ScA__"